import React, {ReactElement} from "react";

import Image, {ImageObject} from "../../image/Image";
import MarkdownText from "../../markdown/markdown-text/MarkdownText";

import {css} from "/src/utils/utils";

import * as styles from "./jtbd-card.module.scss";

interface JTBDCardProps {
  body?: string;
  url?: string;
  eyebrow?: string;
  headline?: string;
  image?: ImageObject;
  classes?: string;
}

const JTBDCard = (props: JTBDCardProps): ReactElement | null => {
  const {body, url, eyebrow, headline, image, classes} = props;

  if (!body && !url && !eyebrow && !headline && !image) {
    return null;
  }

  return (
    <div
      className={css(styles.jtbdCard, url ? styles.jtbdCardUrl : "", classes!)}
    >
      {image && (
        <Image image={image} data-type="image" classes={styles.jtbdCard__img} />
      )}

      {(eyebrow || headline || body) && (
        <div className={styles.jtbdCard__content}>
          {eyebrow && (
            <p className={css("eyebrow", styles.jtbdCard__eyebrow)}>
              {eyebrow}
            </p>
          )}

          {headline && (
            <h4 className={css("h4", styles.jtbdCard__headline)}>
              {url ? (
                <a href={url} className={css(styles.jtbdCard__link)}>
                  {headline}
                </a>
              ) : (
                <>{headline}</>
              )}
            </h4>
          )}

          {body && <MarkdownText text={body} classes={styles.jtbdCard__body} />}
        </div>
      )}
    </div>
  );
};

export default JTBDCard;
